<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="box.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <div class="form-group has-label" :class="valErrors['barcode'] ? 'has-error' : ''">
      <label>Barcode</label>
      <div class="input-group">
        <input aria-describedby="addon-right addon-left" type="text" class="form-control"
          v-model="box.barcode"
        >
        <div class="input-group-append">
          <button class="btn btn-fill btn-secondary" type="button" style="margin-bottom: 0"
            @click="generateBarcode"
          >
          <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
      <div class="text-danger invalid-feedback" style="display: block;"
        v-if="valErrors['barcode']"
      >
        {{ valErrors['barcode'][0] }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8">
        <product-select v-model="product"
          :val-error="valErrors['products'] ? valErrors['products'][0] : null"
        />
      </div>
      <div class="col-sm-3">
        <fg-input label="Menge"
          type="number"
          v-model="quantity"
        />
      </div>
      <div class="col-sm-1 text-center">
        <button class="btn btn-fill btn-primary"
          style="margin-top: 2em;"
          @click.prevent="addProduct"
          :disabled="! product"
        >
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <div v-if="box.products.length" style="margin-bottom: 2em;">
      <div class="row" v-for="addedProduct in box.products" :key="addedProduct.product.id">
        <div class="col-sm-8">
          {{ addedProduct.product.name }}
        </div>
        <div class="col-sm-3">
          <input type="number" class="form-control valid" v-model="addedProduct.quantity">
        </div>
        <div class="col-sm-1 text-center">
          <button class="btn btn-fill btn-danger btn-sm"
            style="vertical-align: sub;"
            @click.prevent="deleteProduct(addedProduct)"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>
    </div>
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
import ProductSelect from 'src/components/product-select'

export default {
  props: ['valErrors', 'initBox', 'submitText'],
  components: { ProductSelect },
  data () {
    return {
      box: this.initBox,
      product: null,
      quantity: null
    }
  },
  methods: {
    submit () {
      if (this.product && this.quantity) {
        this.addProduct()
      }
      this.$emit('submit', this.box)
    },
    addProduct () {
      const index = this.box.products.findIndex(({ product }) => product.id === this.product.id)
      if (index >= 0) {
        this.box.products[index].quantity += +this.quantity
      } else {
        this.box.products.push({
          product: this.product,
          quantity: +this.quantity
        })
      }
      this.product = null
      this.quantity = ''
    },
    deleteProduct (productToDelete) {
      const index = this.box.products.findIndex(({ product }) => product.id === productToDelete.product.id)
      this.box.products.splice(index, 1)
    },
    async generateBarcode () {
      const { data } = await this.$http.get('/barcode/generate')
      this.box.barcode = data
    }
  }
}
</script>

<style>
</style>
